import React, { memo, useEffect, useRef, useState } from 'react';

import { string } from 'prop-types';

import HeaderBottom from '../../../../containers/Templates/A/Header/containers/HeaderBottom';
import HeaderMiddle from '../../../../containers/Templates/A/Header/containers/HeaderMiddle';
import HeaderTop from '../../../../containers/Templates/A/Header/containers/HeaderTop';

import { CollapseStyled, StyledHeader } from './styles';

function Header({ asPath, plataform }) {
  const cartRegex = /\/carrinho(?:\/|$)/;
  const renderComponents = asPath.includes('/cliente') || cartRegex.test(asPath) || asPath.includes('/totem');

  const [visibility, setVisibilty] = useState(false);
  const isMobile = plataform === 'mobile';
  const ref = useRef();

  function handleScroll() {
    const isVisible = window.scrollY <= ref.current.offsetHeight;

    setVisibilty(!isVisible);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledHeader ref={ref}>
      {!renderComponents && !isMobile && (
        <CollapseStyled in={!visibility}>
          <HeaderTop />
        </CollapseStyled>
      )}
      <HeaderMiddle visibility={visibility} renderComponents={renderComponents} isMobile={isMobile} />
      {!renderComponents && !isMobile && (
        <CollapseStyled in={!visibility}>
          <HeaderBottom maxWidth="100%" />
        </CollapseStyled>
      )}
    </StyledHeader>
  );
}

Header.propTypes = {
  asPath: string,
  plataform: string,
};

export default memo(Header);
